import AxiosPost, { AxiosPut } from '../../http/Axios';

const ConfirmRegistration = async (email) => {
  try {
    await AxiosPost(
      '/kidlab-reg/registration/send-confirmation-email',
      { email: email },
      'application/x-www-form-urlencoded'
    );
    await AxiosPut(
      `/kidlab-reg/registration/update-family-details`,
      { email: email },
      'application/x-www-form-urlencoded'
    );
  } catch (err) {
    throw new Error(
      'There was an error submitting your registration. Please try again.'
    );
  }
};
export default ConfirmRegistration;
